const updates = [
  { date: '07-31', title: '《长相思第二季》全集上线，一次看个够', tag: '新剧上线' },
  { date: '07-30', title: '《玫瑰的故事》大结局，刘亦菲演技封神', tag: '热门' },
  { date: '07-29', title: '《唐朝诡事录之西行》更新至第18集', tag: '更新' },
  { date: '07-28', title: '暑期档特别策划：十大必看悬疑剧合集', tag: '专题' },
  { date: '07-27', title: '《你比星光美丽》许凯谭松韵甜蜜开播', tag: '新剧上线' },
  { date: '07-26', title: '播放器升级：支持4K超清画质切换', tag: '公告' },
  { date: '07-25', title: '《墨雨云间》播放量突破50亿，复仇爽剧天花板', tag: '热门' },
  { date: '07-24', title: '韩剧《背着善宰跑》全集上线，双向暗恋甜到炸', tag: '新剧上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">更新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">最新剧集上线与平台公告</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={`${item.date}-${idx}`}
              className="flex items-start gap-4 py-3.5 border-b border-background-200 last:border-0 cursor-pointer hover:bg-background-200/30 px-3 -mx-3 rounded-lg transition-colors"
            >
              <span className="whitespace-nowrap text-xs text-foreground-400 font-medium pt-0.5">{item.date}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800">{item.title}</p>
              </div>
              <span className={`whitespace-nowrap text-xs px-2 py-0.5 rounded-full ${
                item.tag === '新剧上线'
                  ? 'bg-accent-100 text-accent-700'
                  : item.tag === '热门'
                  ? 'bg-primary-100 text-primary-700'
                  : item.tag === '公告'
                  ? 'bg-secondary-100 text-secondary-700'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}